'use strict';

/* ============================================================================
   Dreamtronic — Motion Utils
   Phase 1: IntersectionObserver-Reveal + Hero-Entrance + Cart-Add-Feedback.
   Keine externen Libraries. ~1.2 KB minifiziert.
   ============================================================================ */

(function () {
  var prefersReduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ─── Reveal-on-Scroll ─────────────────────────────────────────────────────
  function initReveals() {
    var targets = document.querySelectorAll('.reveal, .reveal-stagger');
    if (!targets.length) return;

    if (prefersReduced || !('IntersectionObserver' in window)) {
      // Reduced-Motion oder uralter Browser: einfach sofort sichtbar setzen
      targets.forEach(function (el) {
        el.classList.add('is-visible');
        el.style.willChange = '';
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add('is-visible');
        // will-change nach Animationsende entfernen (Memory-Hygiene)
        window.setTimeout(function () { el.style.willChange = ''; }, 1400);
        observer.unobserve(el);
      });
    }, {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.05
    });

    targets.forEach(function (el) { observer.observe(el); });
  }

  // ─── Hero Entrance ────────────────────────────────────────────────────────
  function initHero() {
    var hero = document.querySelector('.hero[data-anim-pending="true"]');
    if (!hero) return;
    if (prefersReduced) {
      hero.removeAttribute('data-anim-pending');
      return;
    }
    // Nach DOM-Paint die CSS-Cascade triggern
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        hero.classList.add('is-revealed');
      });
    });
  }

  // ─── Cart-Add-Feedback (öffentliche API) ──────────────────────────────────
  // Triggert: Badge-Pulse + (optional) Item-Flash beim nächsten Drawer-Render.
  window.dtPulseCartBadge = function () {
    if (prefersReduced) return;
    var badge = document.getElementById('cart-count');
    if (!badge) return;
    badge.classList.remove('is-pulsing');
    // Reflow erzwingen, damit die Animation erneut abspielt
    void badge.offsetWidth;
    badge.classList.add('is-pulsing');
    window.setTimeout(function () {
      badge.classList.remove('is-pulsing');
    }, 520);
  };

  // Markiert das erste Line-Item im Drawer für ein Flash-Highlight.
  // theme.js' renderDrawerItems() erzeugt eigenes Markup — wir picken nach
  // Render das erste Item-DIV in #cart-items-container.
  window.dtFlashFirstCartItem = function () {
    if (prefersReduced) return;
    var container = document.getElementById('cart-items-container');
    if (!container) return;
    var first = container.firstElementChild;
    if (!first) return;
    first.classList.remove('cart-item-flash');
    void first.offsetWidth;
    first.classList.add('cart-item-flash');
    window.setTimeout(function () {
      first.classList.remove('cart-item-flash');
    }, 950);
  };

  // ─── Bootstrap ────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveals();
      initHero();
    });
  } else {
    initReveals();
    initHero();
  }
})();
